<template>
<div style="height:calc(100%);overflow-y:auto;">
  <basicContainer>
    <div class="loadingContainer" v-if="loadingContainer.remind">
        <div class="loadingContainer_icon">
          <i class="el-icon-loading loadingContainer_icon_loading" v-if="loadingContainer.remind === '表格渲染中。。。'" />
          <i class="el-icon-error loadingContainer_icon_error" v-else />
        </div>
        <div class="loadingContainer_remind">
          <p>{{loadingContainer.remind}}</p>
        </div>
      </div>
      <el-tabs v-else v-model="activeName2" type="card" >
        <el-tab-pane v-if="formId"  label="进行中" name="JXZ">
          <DepartmentManage :dicData="dicData" :formId="formId" :tableComment="tableComment" :queryMap="queryMap"></DepartmentManage>
        </el-tab-pane>
        <el-tab-pane v-if="formId"  label="已完成" name="YWC" lazy>
          <DepartmentManageComplete :dicData="dicData" :formId="formId" :tableComment="tableComment" :queryMap="queryMap"></DepartmentManageComplete>
        </el-tab-pane>
      </el-tabs>
  </basicContainer>
</div>
</template>

<script>
import DepartmentManage from './DepartmentManage'
import DepartmentManage_complete from './DepartmentManage_complete'

export default {
  data() {
    return {
      activeName2: this.$route.query.tab || 'JXZ',
      processDefinitionKey: '',
      dicData: [],
      formId: '',
      tableComment: '部门管理',
      queryMap: null,
      // 加载容器控制器
      loadingContainer: {
        remind: '表格渲染中。。。'
      }
    }
  },

  components: { DepartmentManage, DepartmentManageComplete: DepartmentManage_complete },

  mounted: function() {
    let {
      processDefinitionKey
    } = this.$route.query
    if (!processDefinitionKey) {
      this.$message.error('未获取到流程Key,请联系管理员')
      this.$router.push('/404')
      return
    } else {
      this.processDefinitionKey = processDefinitionKey
    }
    this.getLinkDic()
    this.getQueryConditionsByProcessDefinitionKey()
  },
  methods: {
    getLinkDic() {
      this.$http.get('/flow-ext/process-task-list', {
        params: {
          procKey: this.processDefinitionKey,
          containHis: false
        }
      }).then(response => {
        this.dicData = response.data.map(item => ({
          label: item.taskName,
          value: item.taskDefKey
        }))
      }).catch(error => {
        console.log(error)
        // this.loadingContainer.remind = error.msg || error.message
        // this.$message.error(error.msg || error.message)
      })
    },
    getQueryConditionsByProcessDefinitionKey(callback) {
      this.$http.get('/business-list/query-conditions', {
        params: {
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        let queryMap = new Map()
        const setQueryShowType = (item) => {
          // 精确 查询
          if (item.queryType === 'accurate') {
            const { dicOption } = item.propJson
            if (dicOption) {
              item.showType = 'select'
            } else {
              item.showType = 'input'
            }
          } else if (item.queryType === 'blurry') {
            // 模糊
            item.showType = 'input'
          } else if (item.queryType === 'timeRange') {
            // 日期时间范围
            item.showType = 'datetimerange'
          } else if (item.queryType === 'dateRange') {
            item.showType = 'daterange'
          } else {
            item.showType = 'input'
          }
          return item
        }
        response.data.formQueryModelList.forEach(item => {
          queryMap.set(item.prop, setQueryShowType(item))
        })
        this.queryMap = queryMap
        this.formId = response.data.formId
        this.loadingContainer.remind = ''
        this.setTableComment()
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error(error.msg || error.message)
      })
    },
    setTableComment() {
      this.$http.get('/form-model/detail', {
        params: {
          formId: this.formId
        }
      }).then(response => {
        this.tableComment = response.data.name
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error(error.msg || error.message)
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.loadingContainer{
  width:500px;
  margin:0 auto;
  padding: 5px 0;
  color:rgb(59,156,217);
  text-align:center;
  font-weight:600;
  &_icon{
    font-size:25px;
    &_error{ color:red;}
  }
  &_remind{
    p{
      margin: 0;
      width:100%;
    }
  }
}
</style>
